import { render, staticRenderFns } from "./OnetoOneAll.vue?vue&type=template&id=f8d3fbd8&scoped=true"
import script from "./OnetoOneAll.vue?vue&type=script&lang=js"
export * from "./OnetoOneAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3fbd8",
  null
  
)

export default component.exports